import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { NewsletterDTO } from 'frontend/changesets/newsletter';
import { NewsletterChangeset } from 'frontend/changesets/newsletter';
import type FlashMessageService from 'ember-cli-flash/services/flash-messages';
import type {
  ProxyWrappedChangeset,
  ValidationFunction,
} from 'ember-form-changeset-validations';
import type IntlService from 'ember-intl/services/intl';
import NewsletterValidation from 'frontend/validations/newsletter';
import { validateAndMapErrors } from 'common/utils/validate-and-map';
import type FetchService from '@triptyk/ember-utils/services/fetch';

interface BaseNewsletterArgs {}

export default class BaseNewsletter extends Component<BaseNewsletterArgs> {
  @service declare flashMessages: FlashMessageService;
  @service declare intl: IntlService;
  @service declare fetch: FetchService;
  @tracked declare changeset: NewsletterChangeset;

  validationFunction: ValidationFunction<NewsletterDTO> = async (dto) =>
    validateAndMapErrors(NewsletterValidation, dto);

  constructor(owner: unknown, args: BaseNewsletterArgs) {
    super(owner, args);
    this.changeset = new NewsletterChangeset({
      email: '',
    });
  }

  @action
  async subscribeToNewsLetter(
    changeset: ProxyWrappedChangeset<NewsletterChangeset>
  ) {
    try {
      await this.fetch.request('newsletter', {
        body: JSON.stringify({
          email: changeset.get('email'),
        }),
        method: 'POST',
      });
      this.flashMessages.success(
        this.intl.t('components.pages.dashboard.success_message')
      );
    } catch (e: unknown) {
      this.flashMessages.danger(
        this.intl.t('components.pages.dashboard.fail_message')
      );
    }
  }
}
